export default "__VITE_ASSET__BKl32ZRf__"